// extracted by mini-css-extract-plugin
module.exports = {"grid":"VoiceAndTone_grid__DCcn2","item":"VoiceAndTone_item__12OI_","itemActive":"VoiceAndTone_itemActive__3nroq"};